import Vue from 'vue';

// Register all layouts
const requireComponent = require.context('./', true, /.vue$/);
requireComponent.keys().forEach((fileName) => {
  let baseComponentConfig = requireComponent(fileName);
  baseComponentConfig = baseComponentConfig.default || baseComponentConfig;
  if (baseComponentConfig.name) {
    Vue.component(baseComponentConfig.name, baseComponentConfig);
  }
});
